import { React, useState, useEffect } from 'react';
import './recruitmentList.scss';
import OfferCard from '../../components/offerCard/offerCard';
import { GetOfferList } from '../../apis/base';

function RecruitmentList() {
  const [offerList, updateOfferList] = useState([]);
  const [pageInfo, updatePageInfo] = useState({
    page: 1,
    pageSize: 20,
  });
  const [requestErr, updateRequestErr] = useState(false);
  const [isNoData, updateIsNoData] = useState(false);

  const [count, updateCount] = useState(0);
  // const [errorInfo, updateErrorInfo] = useState('');
  // 获取招聘信息列表页面数据
  const getOffersList = (page, pageSize) => {
    const params = {
      exclude: 'aboutWeTV,apply,qualifications',
      page,
      size: pageSize,
      filter: 'isShow=true',
      sort: 'sort',
      order: 'asc'
    }
    GetOfferList(params).then((res) => {
      updateOfferList([...res]);
    }, (_err) => {
      updateRequestErr(true);
    });
  };
  // 获取招聘信息总数
  const getOffersListCount = () => {
    const params = {
      count: 1,
      filter: 'isShow=true',
    }
    GetOfferList(params).then((res) => {
      const count = res.total || 0;
      if (count === 0) {
        updateIsNoData(true);
      }
      updateCount(count);
    }, (_err) => {
      updateRequestErr(true);
    });
  };

  const nextPageClick = () => {
    const pageCount = Math.ceil(count / pageInfo.pageSize);
    if (pageInfo.page === pageCount) return;
    updatePageInfo({
      ...pageInfo,
      page: pageInfo.page + 1,
    });
  };

  const prevPageClick = () => {
    if (pageInfo.page === 1) return;
    updatePageInfo({
      ...pageInfo,
      page: pageInfo.page - 1,
    });
  };
  useEffect(() => {
    getOffersList(pageInfo.page, pageInfo.pageSize);
  }, [pageInfo]);

  useEffect(() => {
    getOffersListCount();
  }, [])

  return (
    <div className="recruitmentList">
      <h2 className='recruitmentListTitle'>
        WeTV CAREERS
      </h2>
      {!requestErr && !isNoData ? (
        <div>
          {offerList.map((item, index) => (
            <OfferCard
              key={index}
              offer={item}
            >
            </OfferCard>
          ))}
          {count > pageInfo.pageSize ? (
            <div className="fliterPage">
              <div className="leftBtn" onClick={prevPageClick}>
                <svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 2L2 8.5L9 15" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="pageSizeInfo">
                <span className="theCurPage">Page {pageInfo.page} </span>
                of
                <span> {Math.ceil(count / pageInfo.pageSize)}</span>
              </div>
              <div className="rightBtn" onClick={nextPageClick}>
                <svg width="11" height="17" viewBox="0 0 11 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 15L9 8.5L2 2" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
          ) : (<></>)}
        </div>
      ) : (
        <div className="pageAppearErr">
          {requestErr ? 'Please refresh the page and try again' : ''}
          {(isNoData && !requestErr) ? 'No recruitment information' : ''}
        </div>
      )}
    </div>
  );
}

export default RecruitmentList;
